module.exports = __webpack_public_path__ + "static/dzemo-share-image-a6e20ccfb64e0567fe58aeb45b3a9c15.png";